export class SetUserOffline {
    public static readonly type = '[Root state] Set user offline';

    constructor(public uuid: string) {}
}
